'use client'

import { useEffect } from 'react'
import { usePathname, useRouter } from 'next/navigation'
import { completeLessonPart } from '@/app/lesson/actions'
import { flushQueue, partOf, readQueue } from '@/lib/lesson-sync'
import { createClient } from '@/lib/supabase/client'
import { hasGuestProgress } from '@/lib/guest-progress'
import { runGuestImport } from '@/components/guest-sync'

// Тикет 70: уроки и их части, не сохранённые из-за обрыва сети, уходят при
// возврате сети и при каждом открытии приложения. Повтор всегда с `since`,
// без дублей; записи без part - уроки целиком из старой очереди (часть 3).
// Запуск и при смене адреса: вход гостя после первого урока (lib/guest-lesson.ts)
// идёт переходом без перезагрузки, а его части 1 и 2 ждут в очереди.
// Уроки, пройденные гостем (lib/guest-progress.ts), переносятся после входа
// страницей /guest-sync; если человек вошёл иначе (кнопка "Войти" на лендинге),
// перенос запускается здесь, как только есть сессия, и страница обновляется.
export function LessonSyncFlusher() {
  const pathname = usePathname()
  const router = useRouter()
  useEffect(() => {
    if (pathname.startsWith('/guest-sync')) return
    const { data } = createClient().auth.onAuthStateChange((_event, session) => {
      if (!session?.user?.id || !hasGuestProgress()) return
      // Вне обработчика: внутри onAuthStateChange вызовы supabase могут ждать друг друга.
      setTimeout(() => {
        runGuestImport().then((r) => r.sent > 0 && router.refresh(), () => {})
      }, 0)
    })
    return () => data.subscription.unsubscribe()
  }, [pathname, router])
  useEffect(() => {
    let busy = false
    const run = async () => {
      if (busy || !navigator.onLine || readQueue().length === 0) return
      busy = true
      try {
        await flushQueue((p) =>
          completeLessonPart(p.lessonId, partOf(p), p.vocabIds, p.missedIds, p.timezone, p.seconds, partOf(p) === 3 ? p.score : null, p.since),
        )
      } finally {
        busy = false
      }
    }
    run()
    window.addEventListener('online', run)
    const onVisible = () => document.visibilityState === 'visible' && run()
    document.addEventListener('visibilitychange', onVisible)
    return () => {
      window.removeEventListener('online', run)
      document.removeEventListener('visibilitychange', onVisible)
    }
  }, [pathname])
  return null
}
